import React from 'react';
import { CalendarDaysIcon, ExternalLinkIcon } from 'lucide-react';
export function RegistrationCallout() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-1561">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-1562">
        <div className="flex items-center gap-4 p-6 rounded-xl mb-12 shadow-sm" style={{
        backgroundColor: '#1e3d2f'
      }} data-id="element-1563">
          <CalendarDaysIcon size={24} className="flex-shrink-0" style={{
          color: '#c8a84b'
        }} data-id="element-1564" />
          <div className="flex-1" data-id="element-1565">
            <p className="text-sm mb-1" style={{
            color: '#a0c8b0',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1566">
              Ready to get started?
            </p>
            <a href="https://www.fentonlakes.com/m7/02--nra-first-steps-pistol.html" target="_blank" rel="noopener noreferrer" className="text-base font-semibold transition-colors hover:underline" style={{
            color: '#c8a84b',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1567">
              Register for this Class — Click Here
            </a>
          </div>
          <ExternalLinkIcon size={20} className="flex-shrink-0" style={{
          color: '#a0c8b0'
        }} data-id="element-1568" />
        </div>
      </div>
    </div>;
}